import stringToHtml from "lib/stringToHtml";
import stripHtml from "lib/stripHtml";
import { truncate } from "lodash";

export const shortenToHtml = (text, length = null) => {
  return `${stringToHtml(stripHtml(text.slice(0, length || Infinity)))}${
    length && text.length > length ? "…" : ""
  }`;
};

export function extractHost(url: string) {
  try {
    return new URL(url).host;
  } catch {
    return null;
  }
}

export function extractDomain(url: string) {
  try {
    const urlParts = new URL(url).hostname.split(".");
    const path = urlParts.slice(urlParts.length - 2, 2).join(".");

    return truncate(path, { length: 40 });
  } catch {
    return null;
  }
}
